<template>
  <v-container fluid class="asc-query-container pa-0">
    <v-row
      no-gutters
      style="flex-wrap: nowrap"
      class="align-content-space-between"
    >
      <v-col
        :style="{ minWidth: `calc(100% - ${gridWidth}px - 24px)` }"
        :class="[
          !isReadOnly ? 'flex-grow-0' : '',
          'flex-shrink-1',
          isCustomAnalytic
            ? 'd-flex flex-column query-builder-menu-wrapper'
            : 'mr-6',
        ]"
      >
        <div
          id="asc-query"
          :class="[
            'v-input theme--light v-textarea v-textarea--auto-grow v-text-field v-text-field--is-booted',
            focused ? 'primary--text' : null,
          ]"
        >
          <div class="v-input__control">
            <div id="input_container" class="v-input__slot">
              <div
                class="v-text-field__slot"
                style="
                   {
                    position: 'relative';
                  }
                "
              >
                <asc-tooltip
                  :tooltip="isDataBricksRunning ? tooltipMsg : ''"
                  :tooltip-length="100"
                  :left="true"
                >
                  <label
                    v-if="label"
                    :for="id"
                    :class="[
                      'v-label theme--light',
                      inputValue.length || focused
                        ? !isReadOnly
                          ? 'v-label--active primary--text'
                          : 'v-label--active'
                        : null,
                    ]"
                    :style="{
                      left: 0,
                      right: 'auto',
                      position: 'absolute',
                      fontSize:
                        !inputValue.length || focused ? '0.9em' : 'inherit',
                    }"
                    >{{ label }}</label
                  >
                </asc-tooltip>
                <textarea
                  :id="id"
                  ref="ascQueryInput"
                  class="asc-query-input v-input"
                  autocomplete="off"
                  autocorrect="off"
                  autocapitalize="off"
                  spellcheck="false"
                  :disabled="isDataBricksRunning || isReadOnly"
                  @focusout="focusout"
                  @focus="onFocus"
                  @keydown="onKeyDown"
                  @click="onClick"
                  @input="updateValue"
                  @paste="onPaste"
                ></textarea>
                <v-menu
                  ref="menu"
                  v-model="isMenuActive"
                  :position-x="x"
                  :position-y="y"
                  absolute
                  offset-y
                  :nudge-bottom="26"
                  :rounded="false"
                  close-on-click
                  style="min-width: 200px; background-color: #fff"
                  tabindex="-1"
                  content-class="query-builder-menu"
                  attach="#input_container"
                >
                  <v-list
                    class="pa-0"
                    style="
                      min-width: 200px;
                      max-width: 350px;
                      max-height: 300px;
                      background-color: #fff;
                    "
                  >
                    <v-list-item
                      v-for="(item, index) in searchMatch.slice(
                        0,
                        typeAheadListLimit,
                      )"
                      :key="index"
                      active-class="query-item-active"
                      @click="selectItem($event, index)"
                    >
                      <v-list-item-content>
                        <v-list-item-title v-text="item.text">
                        </v-list-item-title>
                        <v-list-item-subtitle
                          v-if="item.value && item.isParameter"
                          v-text="item.value"
                        >
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>

            <div class="v-text-field__details">
              <div class="v-messages theme--light error--text">
                <div class="v-messages__wrapper">
                  <ul
                    v-if="messages.invalidParameter || messages.invalidOperator"
                  >
                    <li
                      v-for="(param, index) in messages.invalidParameter"
                      :key="`parameter-${index}`"
                    >
                      Invalid Param {{ param }}
                    </li>
                    <li
                      v-for="(operator, index) in messages.invalidOperator"
                      :key="`operator-${index}`"
                    >
                      Invalid Operator {{ operator }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="isCustomAnalytic"
          :class="[
            'validate-container d-flex flex-column justify-center align-center pa-3',
            !isReadOnly ? 'custom-analytic-style' : '',
          ]"
        >
          <asc-accent-button
            v-if="!isReadOnly"
            class="w-100"
            secondary
            block
            button-text="Validate logic"
            :on-click="handleValidate"
            :loading="validateLoading"
            :disabled="
              !isValidParameters ? true : enableValidateButton ? false : true
            "
            style="width: 100%"
          >
          </asc-accent-button>
        </div>
      </v-col>
      <v-col
        class="flex-grow-0 flex-shrink-0"
        :style="{ width: `${gridWidth}px` }"
      >
        <asc-query-builder-function-grid
          v-if="!isReadOnly"
          :tooltip-msg="tooltipMsg"
          :is-data-bricks-running="isDataBricksRunning"
          :grid-width="isCustomAnalytic ? gridWidth + 24 : gridWidth"
          :configuration-option="configurationOption"
          :expression-options="expressionOptions"
          :is-advanced-full-flight="isAdvancedFullFlight"
          :is-advanced-dplf="isAdvancedDplf"
          :message-codes="messageCodeItems"
          :parameter-list="parameterItems"
          :flight-phase-list="flightPhaseItems"
          :advanced-function-list="advancedFunctionItems"
          @input="onExpressionInput"
        ></asc-query-builder-function-grid>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import _ from 'lodash'
import AscQueryBuilderFunctionGrid from '@/components/molecules/AscQueryBuilderFunctionGrid'
import AscAccentButton from '@/components/atoms/AscAccentButton'
import AscTooltip from '@/components/atoms/AscTooltip'
;(function () {
  var properties = [
    'direction',
    'boxSizing',
    'width',
    'height',
    'overflowX',
    'overflowY',
    'borderTopWidth',
    'borderRightWidth',
    'borderBottomWidth',
    'borderLeftWidth',
    'borderStyle',
    'paddingTop',
    'paddingRight',
    'paddingBottom',
    'paddingLeft',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'fontStretch',
    'fontSize',
    'fontSizeAdjust',
    'lineHeight',
    'fontFamily',
    'textAlign',
    'textTransform',
    'textIndent',
    'textDecoration',
    'letterSpacing',
    'wordSpacing',
    'tabSize',
    'MozTabSize',
  ]

  var isBrowser = typeof window !== 'undefined'
  var isFirefox = isBrowser && window.mozInnerScreenX != null

  function getCaretCoordinates(element, position, options) {
    if (!isBrowser) {
      throw new Error(
        'textarea-caret-position#getCaretCoordinates should only be called in a browser',
      )
    }

    var debug = (options && options.debug) || false
    if (debug) {
      var el = document.querySelector(
        '#input-textarea-caret-position-mirror-div',
      )
      if (el) el.parentNode.removeChild(el)
    }

    // The mirror div will replicate the textarea's style
    var div = document.createElement('div')
    div.id = 'input-textarea-caret-position-mirror-div'
    document.body.appendChild(div)

    var style = div.style
    var computed = window.getComputedStyle
      ? window.getComputedStyle(element)
      : element.currentStyle // currentStyle for IE < 9
    var isInput = element.nodeName === 'INPUT'

    // Default textarea styles
    style.whiteSpace = 'pre-wrap'
    if (!isInput) style.wordWrap = 'break-word' // only for textarea-s

    // Position off-screen
    style.position = 'absolute' // required to return coordinates properly
    if (!debug) style.visibility = 'hidden' // not 'display: none' because we want rendering

    // Transfer the element's properties to the div
    properties.forEach(function (prop) {
      if (isInput && prop === 'lineHeight') {
        // Special case for <input>s because text is rendered centered and line height may be != height
        if (computed.boxSizing === 'border-box') {
          var height = parseInt(computed.height)
          var outerHeight =
            parseInt(computed.paddingTop) +
            parseInt(computed.paddingBottom) +
            parseInt(computed.borderTopWidth) +
            parseInt(computed.borderBottomWidth)
          var targetHeight = outerHeight + parseInt(computed.lineHeight)
          if (height > targetHeight) {
            style.lineHeight = height - outerHeight + 'px'
          } else if (height === targetHeight) {
            style.lineHeight = computed.lineHeight
          } else {
            style.lineHeight = 0
          }
        } else {
          style.lineHeight = computed.height
        }
      } else {
        style[prop] = computed[prop]
      }
    })

    if (isFirefox) {
      if (element.scrollHeight > parseInt(computed.height))
        style.overflowY = 'scroll'
    } else {
      style.overflow = 'hidden'
    }

    div.textContent = element.value.substring(0, position)
    if (isInput) div.textContent = div.textContent.replace(/\s/g, '\u00a0')

    var span = document.createElement('span')
    span.textContent = element.value.substring(position) || '.'
    div.appendChild(span)
    var coordinates = {
      top: span.offsetTop + parseInt(computed['borderTopWidth']),
      left: span.offsetLeft + parseInt(computed['borderLeftWidth']),
      height: parseInt(computed['lineHeight']),
    }

    if (debug) {
      span.style.backgroundColor = '#aaa'
    } else {
      document.body.removeChild(div)
    }

    return coordinates
  }

  if (typeof module != 'undefined' && typeof module.exports != 'undefined') {
    module.exports = getCaretCoordinates
  } else if (isBrowser) {
    window.getCaretCoordinates = getCaretCoordinates
  }
})()

export default {
  name: 'AscQueryBuilder',

  components: {
    AscQueryBuilderFunctionGrid,
    AscAccentButton,
    AscTooltip,
  },

  props: {
    tooltipMsg: {
      type: String,
      default: '',
    },
    isDataBricksRunning: {
      type: Boolean,
      default: false,
    },
    enableValidateButton: {
      type: Boolean,
      default: true,
    },
    isCustomAnalytic: {
      type: Boolean,
      default: false,
    },
    validateLoading: {
      type: Boolean,
      default: false,
    },
    isValidParameters: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    gridWidth: {
      type: Number,
      default: 400,
    },
    allowedCharacters: {
      type: Object,
      default: () => {},
    },
    expressionOptions: {
      type: Array,
      default: () => [],
    },
    configurationOption: {
      type: String,
      default: '',
    },
    isAdvancedFullFlight: {
      type: Boolean,
      default: false,
    },
    isAdvancedDplf: {
      type: Boolean,
      default: false,
    },
    messageCodes: {
      type: Array,
      default: () => [],
    },
    parameterList: {
      type: Array,
      default: () => [],
    },
    flightPhaseList: {
      type: Array,
      default: () => [],
    },
    advancedFunctionList: {
      type: Array,
      default: () => [],
    },
    allowAutocomplete: {
      type: Boolean,
      default: false,
    },
    expressionValue: {
      type: String,
      default: '',
    },
    typeAheadListLimit: {
      type: Number,
      default: 15,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isMenuActive: false,
      initialWatchInputComplete: false,
      initialWatchExpressionComplete: false,
      x: 0,
      y: 0,
      id: 'input-' + uuidv4(),
      inputValue: '',
      searchMatch: [],
      selectedIndex: -1,
      clickedChooseItem: false,
      currentWord: {
        string: '',
        position: {},
      },
      previousWord: {
        string: '',
        position: {},
      },
      valid: false,
      focused: false,
      allowedSpecialCharsKeyCodes: Object.freeze(this.allowedCharacters),
      keyCodes: Object.freeze({
        enter: 13,
        tab: 9,
        delete: 46,
        esc: 27,
        space: 32,
        up: 38,
        down: 40,
        left: 37,
        right: 39,
        end: 35,
        home: 36,
        del: 46,
        backspace: 8,
        insert: 45,
        pageup: 33,
        pagedown: 34,
        shift: 16,
        capsLock: 20,
      }),
      messages: {
        invalidParameter: [],
        invalidOperation: [],
        invalidOperator: [],
      },
    }
  },

  computed: {
    parameterItems() {
      let mappedParameters = []
      if (this.parameterList && this.parameterList.length) {
        // if its a FullFlightParameterList
        if (this.isAdvancedFullFlight) {
          mappedParameters = this.parameterList.map(
            ({ dataElementId, name, rawName, groupName, id }) => {
              return {
                id: dataElementId ? dataElementId : id ? id : undefined,
                text: name?.replace(/_/g, ' '),
                value: `[${rawName}]`,
                groupName: groupName ? groupName : undefined,
                isParameter: true,
                allowAtStart: true,
              }
            },
          )
        } else {
          // If its a ACMF
          mappedParameters = this.parameterList.map(
            ({ acmfDataElementId, parameterName, shortName }) => {
              return {
                id: acmfDataElementId,
                text: shortName,
                value: `[${parameterName}]`,
                isParameter: true,
                allowAtStart: true,
              }
            },
          )
        }
      }
      return mappedParameters
    },

    messageCodeItems() {
      // Sample response, messageCodes = [2165142,2214090,2413866]
      // Insert Format [MESSAGE_CODE] = NNNNNNN
      if (this.isAdvancedDplf) {
        return this.messageCodes?.map(messageCode => {
          return {
            text: messageCode,
            value: `[MESSAGE_CODE] = ${messageCode}`,
            isMessageCode: true,
            allowAtStart: true,
          }
        })
      }
      return [] // Default value should be an array
    },

    flightPhaseItems() {
      return this.flightPhaseList?.map(flightPhaseObj => {
        return {
          text: flightPhaseObj.text,
          value: `FLIGHTPHASE(${flightPhaseObj.value})`,
          isFlightPhase: true,
          allowAtStart: true,
        }
      })
    },

    advancedFunctionItems() {
      if (!this.disabledAdvFunction) {
        const mappedFunctions = this.advancedFunctionList.map(functionObj => {
          return {
            text: functionObj,
            value: functionObj,
            isAdvancedFunction: true,
            isFunction: true,
            allowAtStart: true,
          }
        })
        return mappedFunctions
      } else {
        return []
      }
    },

    operationItems() {
      if (this.expressionOptions && this.expressionOptions.length > 0) {
        return this.expressionOptions.filter(option => option.isOperation)
      } else {
        return []
      }
    },

    operatorItems() {
      if (this.expressionOptions && this.expressionOptions.length > 0) {
        return this.expressionOptions.filter(option => option.isOperator)
      } else {
        return []
      }
    },

    // Move this logic to container
    disabledAdvFunction() {
      if (
        this.isAdvancedDplf ||
        this.isAdvancedFullFlight ||
        this.configurationOption === 'aggregateDays' ||
        this.configurationOption === 'aggregateReports'
      ) {
        return false
      }

      return true
    },
  },
  watch: {
    expressionValue: function () {
      this.focused = true
      const target = this.$refs.ascQueryInput
      const textNode = document.createTextNode(this.expressionValue)
      target.appendChild(textNode)
      this.$emit('input', this.decodeQueryInput())
      if (this.initialWatchExpressionComplete) {
        this.$emit('isDirty')
      }
      this.inputValue = this.decodeQueryInput()
      this.initialWatchExpressionComplete = true
    },

    inputValue: function () {
      this.onFocus()
      this.selectedIndex = -1
      this.$emit('input', this.decodeQueryInput())
      if (this.initialWatchInputComplete) {
        this.$emit('isDirty')
      }
      this.initialWatchInputComplete = true
    },

    parameterItems: function () {
      this.validator()
    },
    messageCodeItems: function () {
      this.validator()
    },
  },
  methods: {
    handleValidate() {
      this.$emit('handleValidate')
    },
    getCurrentWord(e) {
      if (e.target.value && e.target.selectionStart) {
        const start = e.target.value
          .substring(0, e.target.selectionStart)
          .match(/[a-zA-Z0-9 _[*>=<!+-/]+$/)
        // OLD .match(/[a-zA-Z0-9-_[(]+$/)

        const end = e.target.value
          .substring(e.target.selectionStart)
          .match(/^[a-zA-Z0-9 _(\]]+/)

        if (start && start.length > 0 && !start[0].includes('[')) {
          this.previousWord = this.currentWord
        }

        if (!start && !end) {
          this.currentWord = {
            text: '',
            type: e.type,
            position: {
              start: start ? start.index : 0,
              end: e.target.selectionStart || 0,
            },
          }
        } else {
          const isParameter = start ? start[0].includes('[') : false
          const startWord = start
            ? isParameter
              ? start[0].substring(start[0].lastIndexOf('['))
              : start[0].substring(start[0].lastIndexOf(' '))
            : ''
          const startIndex = start
            ? isParameter
              ? start[0].lastIndexOf('[') && start[0].lastIndexOf('[') > 0
                ? start.index + start[0].lastIndexOf('[') - 1
                : start.index
              : start.index + start[0].lastIndexOf(' ')
            : 0
          // const isFlightPhase = text.toLowerCase().startsWith('f')

          this.currentWord = {
            text: startWord + (startWord.trim() ? end || '' : ''),
            type: e.type,
            position: {
              start: startIndex,
              end: e.target.selectionStart,
            },
          }
        }
      } else this.setDefaultCurrentWord(e)
    },

    setDefaultCurrentWord(e) {
      this.currentWord = {
        text: '',
        type: e.type,
        position: {
          start: 0,
          end: 0,
        },
      }
    },

    decodeQueryInput() {
      const ascQueryInputElement = this.$refs.ascQueryInput
      return ascQueryInputElement.value
    },

    validator() {
      // Validate Params
      this.valid = true
      const decodedValue = this.decodeQueryInput()
      this.messages = { invalidParameter: [], invalidOperator: [] }
      const paramsInQueryEditor = decodedValue.match(/(?<=\[)[^\][]*(?=])/g)
      if (
        paramsInQueryEditor &&
        paramsInQueryEditor.length &&
        this.parameterItems &&
        this.parameterItems.length
      ) {
        paramsInQueryEditor.forEach(param => {
          const found = this.parameterItems.find(
            ({ value }) => value.toLowerCase() === `[${param.toLowerCase()}]`,
          )
          if (!found) {
            this.messages.invalidParameter.push(param)
            this.valid = false
          }
        })
      }

      // Validate special characters/operators
      const invalidSpecialCharacters = decodedValue.match(/[&\\@#$~%`':;^?{}]/g)

      if (invalidSpecialCharacters && invalidSpecialCharacters.length) {
        this.messages.invalidOperator = invalidSpecialCharacters
      }

      this.$emit('onValidateParameters', this.valid, decodedValue)
    },

    insertAtCursor(text, replace = true) {
      const target = this.$refs.ascQueryInput

      if (document.selection) {
        //IE support
        target.focus()
        const sel = document.selection.createRange()
        sel.text = text
      } else if (target.selectionStart || target.selectionStart == '0') {
        // other browsers
        let startPos = this.currentWord.position.start
        let endPos = this.currentWord.position.end

        // To check whether to give space or not at the start of incoming String
        const giveStartingSpace =
          startPos > 0 ? target.value[startPos - 1] === ' ' : true

        startPos =
          target.value[startPos] !== ' ' && target.value[startPos] !== '['
            ? startPos + 1
            : startPos

        const giveEndingSpace = target.value[endPos + 1] === ' '

        if (this.currentWord.text && this.previousWord.text) {
          if (
            this.currentWord.text.startsWith('[') &&
            this.previousWord.text.match(/[*\-<>/+=]/)
          ) {
            target.value = `${target.value.substring(
              0,
              this.previousWord.position.end,
            )}${' '}${target.value.substring(
              this.previousWord.position.end,
              target.value.length,
            )}`
            startPos = this.previousWord.position.end
            endPos = endPos + 1
          }
        }

        target.value = `${target.value.substring(
          0,
          replace ? startPos : endPos,
        )}${!giveStartingSpace && replace ? ' ' : ''}${text}${
          !giveEndingSpace ? ' ' : ''
        }${target.value.substring(endPos, target.value.length)}`

        // if replace is false then its from the grid
        this.currentWord.position = {
          start: replace ? startPos : endPos + text.length + 1,
          end: replace ? startPos : endPos + text.length + 2,
        }
      } else {
        target.value += `${text}`
      }
    },

    updateCaretCoordinates() {
      this.isMenuActive = false
      const target = this.$refs.ascQueryInput
      const coordinates = window.getCaretCoordinates(
        target,
        target.selectionEnd,
      )
      if (coordinates) {
        this.x = coordinates.left
        this.y = coordinates.top
      }

      this.$nextTick(() => {
        this.isMenuActive = true
      })
    },

    updateValue(event) {
      if (event) {
        let text = event.target.value
        this.inputValue = text
        this.updateCaretCoordinates(event)
        this.getCurrentWord(event)
      }
    },

    onClick(event) {
      this.getCurrentWord(event)
    },

    async onPaste(evt) {
      const ascQueryInputElement = this.$refs.ascQueryInput
      ascQueryInputElement.dispatchEvent(new Event('input'))

      this.updateCaretCoordinates(evt)
      this.getCurrentWord(evt)
    },

    onFocus() {
      this.focused = true
      this.searchMatch = []

      const text = this.currentWord.text
        ? this.currentWord.text.trim().toLowerCase()
        : ''

      if (text !== '' && text !== undefined) {
        const isParameter = this.currentWord.text.startsWith('[')
        const isFlightPhase = text.toLowerCase().startsWith('f')

        if (isParameter) {
          // Its a parameter
          if (text.substring(1)) {
            const currentWord = text.substring(1)

            this.searchMatch = this.parameterItems.filter(el => {
              if (currentWord.indexOf('_') > -1) {
                return el.value.toLowerCase().indexOf(text) >= 0
              }
              return el.text.toLowerCase().indexOf(currentWord) >= 0
            })

            if (this.searchMatch.length === 1) {
              if (text.toUpperCase() === this.searchMatch[0].value) {
                this.searchMatch = []
              }
            }
          } else {
            // if its parameter has no other characters other than '[' then show all parameters
            this.searchMatch = _.sortBy(
              this.parameterItems.filter(
                param => param.text && param.text.length,
              ),
              ['text'],
            )
          }
        } else if (isFlightPhase) {
          // Its a FlightPhase
          if (text.substring(12)) {
            const currentWord = text.substring(12)

            this.searchMatch = this.flightPhaseItems.filter(el => {
              return el.text.toLowerCase().indexOf(currentWord + ')') >= 0
            })

            if (this.searchMatch.length === 1) {
              if (text.toUpperCase() === this.searchMatch[0].text) {
                this.searchMatch = []
              }
            }
          } else {
            this.searchMatch = this.flightPhaseItems
          }
        } else {
          const isAdvFunctions = this.advancedFunctionItems.filter(el => {
            return el.text.toLowerCase().indexOf(text) >= 0
          })

          if (isAdvFunctions.length) {
            // If its AdvanceFunctions
            this.searchMatch = isAdvFunctions
            if (this.searchMatch.length === 1) {
              if (text.toUpperCase() === this.searchMatch[0].text) {
                this.searchMatch = []
              }
            }
          }

          const isMessageCodes = this.messageCodeItems.filter(el => {
            // wont work on el.text as indexOf is only supported for string or array
            return el.value.indexOf(text) >= 0
          })

          if (isMessageCodes.length) {
            // If its MessageCodes
            this.searchMatch = isMessageCodes
            if (this.searchMatch.length === 1) {
              if (text == this.searchMatch[0].text) {
                this.searchMatch = []
              }
            }
          }

          const isOperations = this.operationItems.filter(el => {
            return el.text.toLowerCase().indexOf(text) >= 0
          })

          if (isOperations.length) {
            // If its Operations
            this.searchMatch = isOperations
            if (this.searchMatch.length === 1) {
              if (text === this.searchMatch[0].text) {
                this.searchMatch = []
              }
            }
          }

          const isOperators = this.operatorItems.filter(el => {
            return (
              el.text.toLowerCase().indexOf(text) >= 0 ||
              el.alt.toLowerCase().indexOf(text) >= 0
            )
          })

          if (isOperators.length) {
            // If its Operations
            this.searchMatch = isOperators
          }

          if (this.searchMatch.length === 1) {
            if (text.toUpperCase() === this.searchMatch[0].text) {
              this.searchMatch = []
            }
          }
        }
      }
    },

    focusout() {
      this.focused = false
      this.validator()
    },

    onKeyDown(e) {
      const keyCode = e.keyCode
      const key = e.key

      if (
        (keyCode >= 65 && keyCode <= 90) ||
        (key >= 0 && key <= 9) ||
        _.has(this.allowedSpecialCharsKeyCodes, key) ||
        [
          this.keyCodes.backspace,
          this.keyCodes.up,
          this.keyCodes.down,
          this.keyCodes.home,
          this.keyCodes.end,
          this.keyCodes.enter,
          this.keyCodes.left,
          this.keyCodes.right,
          this.keyCodes.delete,
          this.keyCodes.esc,
          this.keyCodes.tab,
        ].includes(keyCode)
      ) {
        const menu = this.$refs.menu
        const activeTile = menu.activeTile

        // No menu list items are selected and on enter key
        if (
          [this.keyCodes.enter].includes(keyCode) &&
          activeTile === undefined
        ) {
          e.preventDefault()
          return false
        }

        this.$emit('keydown', e)
        this.getCurrentWord(e)
        if (!menu) return
        // If menu is active, allow default listIndex change from menu
        if (
          this.isMenuActive &&
          [
            this.keyCodes.up,
            this.keyCodes.down,
            this.keyCodes.home,
            this.keyCodes.end,
            this.keyCodes.enter,
          ].includes(keyCode)
        ) {
          this.$nextTick(() => {
            menu.changeListIndex(e)
            this.$emit('update:list-index', menu.listIndex)
          })
        }

        // If enter, space, open menu
        if ([this.keyCodes.enter, this.keyCodes.space].includes(keyCode))
          this.activateMenu()

        // If menu is not active, up/down/home/end
        if (
          !this.isMenuActive &&
          [
            this.keyCodes.up,
            this.keyCodes.down,
            this.keyCodes.home,
            this.keyCodes.end,
          ].includes(keyCode)
        ) {
          //TODO: handle home and end keys here
          return this.onUpDown(e)
        }

        // If escape deactivate the menu
        if (keyCode === this.keyCodes.esc) return this.onEscDown(e)

        // If tab - select item or close menu
        if (keyCode === this.keyCodes.tab) return this.onTabDown(e)

        // If space preventDefault - Allow spaces
        if (keyCode === this.keyCodes.space) {
          // this.onSpaceDown(e)
        }
      } else {
        e.preventDefault()
        return false
      }
    },

    onUpDown(e) {
      const menu = this.$refs.menu
      const keyCode = e.keyCode

      if (!menu || !this.isMenuActive) {
        switch (keyCode) {
          case this.keyCodes.home:
            this.currentWord = {
              text: '',
              type: e.type,
              position: {
                start: 0,
                end: 0,
              },
            }
            break
          case this.keyCodes.end:
            this.currentWord = {
              text: '',
              type: e.type,
              position: {
                start:
                  this.inputValue.length > 0 ? this.inputValue.length - 1 : 0,
                end: this.inputValue.length,
              },
            }
            break
        }
        e.preventDefault()
        return
      }
      e.preventDefault()
      // Cycle through available values to achieve select native behavior
      menu.isBooted = true
      window.requestAnimationFrame(() => {
        menu.getTiles()
        if (!menu.hasClickableTiles) return this.activateMenu()

        switch (keyCode) {
          case this.keyCodes.up:
            menu.prevTile()
            break
          case this.keyCodes.down:
            menu.nextTile()
            break
          case this.keyCodes.home:
            menu.firstTile()
            break
          case this.keyCodes.end:
            menu.lastTile()
            break
        }
        this.selectItem(e, this.getMenuIndex())
      })
    },

    onSpaceDown(event, selectedItem = null, replace = true) {
      let selectedExpression = selectedItem
      if (selectedExpression) {
        // Item selected by menu and/or
        // If selectedExp is a function type bracketnodes get added below
        const text =
          selectedExpression.isFunction === true
            ? `${selectedExpression.value}(`
            : `${selectedExpression.value}`
        if (!this.currentWord.position.start && !this.currentWord.position.end)
          this.setDefaultCurrentWord(event)
        // Click event is needed for the incoming grid selection string
        const target = this.$refs.ascQueryInput
        target.click()
        this.insertAtCursor(text, replace)
        // TODO: update the cursor position else continious additions from grid is going to insert in wrong place
      } else {
        // Auto complete the text on space
        const text = this.currentWord.text
          ? this.currentWord.text.trim().toLowerCase()
          : ''

        // only trigger if character length is > 3
        const isParameter =
          text && text.length > 3
            ? this.parameterItems.filter(el => {
                return el.value.toLowerCase().indexOf(text) >= 0
              })
            : []

        const isOperations =
          text && text.length > 3
            ? this.operationItems.filter(el => {
                return el.value.toLowerCase().indexOf(text) >= 0
              })
            : []

        const isOperators =
          text && text.length
            ? this.operatorItems.filter(el => {
                return el.text.indexOf(text) >= 0 || el.value.indexOf(text) >= 0
              })
            : []

        const isMessageCode =
          text && text.length > 3
            ? this.messageCodeItems.filter(el => {
                return el.text.indexOf(text) >= 0
              })
            : []

        const isAdvFunction =
          text && text.length > 3
            ? this.advancedFunctionItems.filter(el => {
                return el.text.toLowerCase().indexOf(text) >= 0
              })
            : []

        const isFlightPhase =
          text && text.length > 3
            ? this.flightPhaseItems.filter(el => {
                return el.text.toLowerCase().indexOf(text) >= 0
              })
            : []

        if (
          isParameter.length ||
          isOperations.length ||
          isOperators.length ||
          isMessageCode.length ||
          isAdvFunction.length ||
          isFlightPhase.length
        ) {
          if (isParameter.length) {
            selectedExpression = isParameter[0]
            this.insertAtCursor(isParameter[0].value)
          } else if (isOperations.length) {
            selectedExpression = isOperations[0]
            // If selectedExp is a function type bracketnodes get added below
            this.insertAtCursor(`${isOperations[0].value}( `)
          } else if (isOperators.length) {
            selectedExpression = isOperators[0]
            this.insertAtCursor(isOperators[0].value)
          } else if (isMessageCode.length) {
            selectedExpression = isMessageCode[0]
            this.insertAtCursor(isMessageCode[0].value)
          } else if (isAdvFunction.length) {
            selectedExpression = isAdvFunction[0]
            // No space after value its a function type bracketnodes get added below
            this.insertAtCursor(isAdvFunction[0].value)
          } else if (isFlightPhase.length) {
            selectedExpression = isFlightPhase[0]
            this.insertAtCursor(selectedExpression.value)
          }
        } else {
          this.insertAtCursor(text)
        }
      }

      const target = this.$refs.ascQueryInput
      target.focus()
      const newPosition = target.value.length
      target.setSelectionRange(newPosition, newPosition)

      this.validator()
      this.$emit('input', this.decodeQueryInput())
      this.$emit('isDirty')
      this.inputValue = this.decodeQueryInput()
      // Dont allow any at start like operators, operation etc.. if its from the button click
      // event.preventDefault()
    },

    onEscDown(e) {
      e.preventDefault()
      if (this.isMenuActive) {
        e.stopPropagation()
        this.isMenuActive = false
      }
    },

    onTabDown(e) {
      const menu = this.$refs.menu
      if (!menu) return
      const activeTile = menu.activeTile
      // An item that is selected by menu-index should toggled
      if (this.isMenuActive && activeTile) {
        e.preventDefault()
        e.stopPropagation()
        activeTile.click()
      } else {
        // If we make it here, the user has no selected indexes and is probably tabbing out
        e.preventDefault()
        e.stopPropagation()
        return false
      }
    },

    moveUp() {
      if (this.selectedIndex !== -1) {
        this.selectedIndex--
      }
    },

    selectItem(event, index) {
      this.selectedIndex = index
      this.chooseItem(event, index)
    },

    chooseItem(event) {
      if (this.searchMatch.length === 0) {
        event.preventDefault()
        return false
      }
      this.clickedChooseItem = true

      if (this.selectedIndex !== -1 && this.searchMatch.length > 0) {
        if (event) event.preventDefault()
        this.onSpaceDown(event, this.searchMatch[this.selectedIndex])
        this.searchMatch = []
        this.clickedChooseItem = false
        this.selectedIndex = -1
      }
    },

    onExpressionInput(e, value) {
      this.onSpaceDown(e, value, false)
    },

    activateMenu() {
      if (this.isMenuActive) return
      this.isMenuActive = true
    },

    getMenuIndex() {
      return this.$refs.menu ? this.$refs.menu.listIndex : -1
    },
  },
}
</script>

<style lang="scss">
.query-builder-menu-wrapper {
  border: 1px solid $gray-100;
}
.query-builder-menu {
  background-color: $primary-white;

  .v-list-item {
    border-left: 4px solid transparent;
    background-color: $primary-white;

    &--active,
    &--highlighted,
    &:hover,
    &:focus {
      border-left: 4px solid $accent-500;
      background-color: $primary-white;

      &:before {
        opacity: 0.07 !important;
      }
    }

    .v-list-item__content {
      .v-list-item__subtitle {
        color: $caution-base;
      }
    }
  }
}
</style>

<style lang="scss" scoped>
.asc-query-container {
  .v-textarea,
  .v-input__control,
  .v-input__slot,
  .v-text-field__slot {
    height: 100%;
  }

  .v-input__control {
    flex-wrap: nowrap;
    padding: 10px;
  }

  .v-text-field > .v-input__control > .v-input__slot:before {
    border-style: none !important;
  }

  .asc-query {
    height: 100%;

    &-input {
      color: rgba(0, 0, 0, 0.87);
      flex: 1 1 auto;
      line-height: 20px;
      padding: 8px 0;
      max-width: 100%;
      min-width: 0;
      width: 100%;
      outline: none;
      font-size: 1rem;
    }
  }
  .custom-analytic-style {
    background-color: $gray-100;
  }
}
</style>
